import {AiFillLinkedin} from 'react-icons/ai'
import {AiFillGithub} from 'react-icons/ai'
import {AiOutlineTwitter} from 'react-icons/ai'

const data = [
  {
    id: 1,
    link: "https://www.linkedin.com/in/subhashis-nath-a6a2a624",
    icon: <AiFillLinkedin />,
  },
  { 
    id: 2,
    link: "https://github.com/subha81788",
    icon: <AiFillGithub />,
  },
  {
    id: 3,
    link: "https://twitter.com/SubhashisN88",
    icon: <AiOutlineTwitter />,
  },
];

export default data